// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-theme-homestead -> weidner-apartment-homes-theme-homestead -> pheasant-ridge
// Generated: 2026-10-29T23:13:37.201Z
// Counts: 0 design, 15 content, 17 slot group, 2 collection binding, 8 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 12pt;\"><strong>At Pheasant Ridge Apartment Homes, you're right in the heart of Watford City, ND.</strong> Stroll to Doc Nelson Dog Park or explore nearby Sunshine Park for outdoor fun. Local shops, restaurants, bars, and Main Street nightlife are just blocks away, while the Watford City Municipal Airport and Cash-Wise Foods are close for convenient travel and errands. Every day brings options - from weekend outings and scenic parks to your go-to coffee shop downtown. This is Watford City living at its best.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 12pt;\"><strong>Searching for apartments for rent in Watford City, ND?</strong> Pheasant Ridge Apartment Homes brings you steps from Doc Nelson Dog Park, Stonehome Brewery, and the shops and dining of North Main Street. Settle into a pet-friendly community where comfort meets convenience. Enjoy flexible leasing, free on-site parking, and a warm, inviting atmosphere designed for living your way. Find your space, your favorite destinations, and a down-to-earth feel, all here at Pheasant Ridge.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Cozy Apartments in Watford City, ND</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 12pt;\"><strong>Everyday Amenities at Pheasant Ridge. </strong>At Pheasant Ridge in Watford City, ND, in-home comforts and community conveniences blend for a seamless living experience. Enjoy large walk-in closets, a washer and dryer in every apartment, central air and heat, and open floor plans. Live within a pet-friendly community that offers on-site snow removal, single garages, open parking, and the peace of mind from 24-hour emergency maintenance. Here, your home is thoughtfully designed to support your needs day after day.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 12pt;\"><strong>We'd love to hear from you.</strong> Contact the Pheasant Ridge leasing team in Watford City, ND, for details about floor plans, availability, or to schedule your personal tour. Our friendly team is here to help you make your next move.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 12pt;\"><strong>Explore Spacious Floor Plans at Pheasant Ridge. </strong>Choose from stunning one-, two-, and three-bedroom apartments for rent in Watford City, ND, at Pheasant Ridge. Each home welcomes you with open layouts and touches that make everyday life simple - like a washer and dryer in every unit and large walk-in closets. Whether you need extra space to work from home or prefer a cozy nook to unwind, you'll find a floor plan that fits your needs and gives you room to breathe.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 12pt;\"><strong>See everyday moments at Pheasant Ridge in Watford City, ND.</strong> Scroll through our photo gallery to see thoughtfully designed kitchens, cozy bedrooms, spacious living areas, and the welcoming vibe across our community. Imagine mornings on your balcony or relaxed evenings with your four-legged friend nearby. Ready to picture life closer? Take a look and see what feels like home.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 12pt;\"><strong>Schedule a Tour of Pheasant Ridge Apartments. </strong>Explore your future apartment at Pheasant Ridge in Watford City, ND, with our flexible tour options. Choose a private in-person tour, a live virtual walkthrough, or view apartments online at your pace. Our knowledgeable leasing professionals are ready to show you why Pheasant Ridge is a welcoming place to call home. Touring restrictions may apply.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 12pt;\"><strong>The Pheasant Ridge virtual tour brings Watford City living to your screen.</strong> Explore spacious layouts, comfortable spaces, and the friendly atmosphere from wherever you are. See highlights of our apartments and get a feel for the welcoming environment at Pheasant Ridge - preview life here before stepping through our doors. Ready to take the next step? Start touring today or reach out for a personal in-person experience.</span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "floorplanslist.contact_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your Space"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.youtube_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.youtube.com/@WeidnerApartmentHomes"
      }
    }
  },
  "header.drawer_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_mono_white_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_mono_white_logo_media.alt_text"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "amenities[21].amenity_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "amenities[21].amenity_image_media.alt_text"
      }
    }
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "amenities[24].amenity_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "amenities[24].amenity_image_media.alt_text"
      }
    }
  },
  "gallery-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[8].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[8].image_media.alt_text"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[19].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[19].image_media.alt_text"
      }
    }
  },
  "imagecallouts.tile1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0228-0551-75c9-bf89-cea833febfae.webp"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Live Better"
      },
      "subtitle": {
        "type": "GENERATOR",
        "generatedValue": "Take A Virtual Tour"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior living area of an apartment with carpet, wood entry flooring, and a sliding glass door to a balcony."
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "/virtual-tour"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_self"
      }
    }
  },
  "imagecallouts.tile2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0228-0572-737a-bab2-91a8fc5d2534.webp"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Luxury Design"
      },
      "subtitle": {
        "type": "GENERATOR",
        "generatedValue": "View The Gallery"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment bathroom with double-sink vanity, large mirror, toilet, and shower-tub."
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "/gallery"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_self"
      }
    }
  },
  "imagecallouts.tile3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0228-071a-7678-82c5-1266a12b8818.webp"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Local Charm"
      },
      "subtitle": {
        "type": "GENERATOR",
        "generatedValue": "Explore The Neighborhood"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a modern apartment building with multiple levels, balconies, and a landscaped courtyard."
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "/neighborhood"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_self"
      }
    }
  },
  "imagecallouts.tile4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0228-10a1-7486-81e7-00258e350a77.webp"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Unmatched Convenience"
      },
      "subtitle": {
        "type": "GENERATOR",
        "generatedValue": "Explore Our Amenities"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Laundry room with a white washer and dryer and wire shelving along the walls."
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "/amenities"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_self"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "amenities[1].amenity_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "amenities[1].amenity_image_media.alt_text"
      }
    }
  },
  "parallaxbanner.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[20].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[20].image_media.alt_text"
      }
    }
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[2].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[2].image_media.alt_text"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "floorplanslist.gallery": {
    "limit": null,
    "hiddenIds": [
      "ec_4799c4231b3725e78d5e9143",
      "ec_ecfa25baabdef8a009225df6"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.slideshow": {
    "limit": null,
    "hiddenIds": [
      "ec_4799c4231b3725e78d5e9143"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
